<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">
      {{ modalLabel }}
    </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="otherMaterialAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="otherMaterialAddEditForm.get('material')?.value"
              class="sub-header-drpdown pb-2"
              >Conversion process</label
            >
            <label
              *ngIf="
                !otherMaterialAddEditForm.get('material')?.value &&
                otherMaterialAddEditForm.get('organizationName')?.value
              "
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #material
              [items]="materialList"
              [searchable]="false"
              bindValue="id"
              bindLabel="description"
              formControlName="material"
              [readonly]="true"
              [searchFn]="commonInputSearch"
              placeholder="Conversion process"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="material.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="submitted && otherMaterialAddEditForm.controls['material']?.invalid"
              class="input-error"
            >
              Material process is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="otherMaterialAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <label
              *ngIf="
                otherMaterialAddEditForm.get('material')?.value &&
                !otherMaterialAddEditForm.get('organizationName')?.value
              "
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isMaterialTypeForm" formGroupName="materialTypeForm">
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="plasticResin"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Plastic resin"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Plastic resin</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('plasticResin')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('materialTypeForm')?.get('plasticResin')?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('plasticResin')?.errors
                  "
                >
                  Plastic resin is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="paperBoard"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Paper board"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Paper board</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('paperBoard')?.errors) ||
                  otherMaterialAddEditForm.get('materialTypeForm')?.get('paperBoard')?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('paperBoard')?.errors
                  "
                >
                  Paper board is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="metals"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Metals"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Metals</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('metals')?.errors) ||
                  otherMaterialAddEditForm.get('materialTypeForm')?.get('metals')?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="otherMaterialAddEditForm.get('materialTypeForm')?.get('metals')?.errors"
                >
                  Metals is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="glass"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Glass"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Glass</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('glass')?.errors) ||
                  otherMaterialAddEditForm.get('materialTypeForm')?.get('glass')?.touched
                "
                class="input-error"
              >
                <div *ngIf="otherMaterialAddEditForm.get('materialTypeForm')?.get('glass')?.errors">
                  Glass is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="otherMaterials"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Other materials"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Other materials</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('otherMaterials')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('materialTypeForm')?.get('otherMaterials')?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('materialTypeForm')?.get('otherMaterials')?.errors
                  "
                >
                  Other materials is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isRecyclabilityForm" formGroupName="recyclabilityForm">
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="recyclabilityHigh"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Recyclability high"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Recyclability high</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityHigh')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityHigh')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityHigh')
                      ?.errors
                  "
                >
                  Recyclability high is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="recyclabilityLow"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Paper board"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Recyclability low</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityLow')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityLow')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityLow')
                      ?.errors
                  "
                >
                  Recyclability low is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="recyclabilityMedium"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Recyclability medium"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Recyclability medium</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityMedium')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityMedium')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityMedium')
                      ?.errors
                  "
                >
                  Recyclability medium is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="recyclabilityNone"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Recyclability none"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Recyclability none</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityNone')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityNone')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('recyclabilityForm')?.get('recyclabilityNone')
                      ?.errors
                  "
                >
                  Recyclability none is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isCombustibilityForm" formGroupName="combustibilityForm">
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="combustibilityHigh"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Combustibility high"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Combustibility high</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityHigh')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityHigh')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityHigh')
                      ?.errors
                  "
                >
                  Combustibility high is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="combustibilityLow"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Combustibility  Low"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Combustibility low</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityLow')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityLow')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityLow')
                      ?.errors
                  "
                >
                  Combustibility low is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="combustibilityNone"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Recyclability medium"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Combustibility none</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityNone')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityNone')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('combustibilityForm')?.get('combustibilityNone')
                      ?.errors
                  "
                >
                  Combustibility none is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isCompostabilityForm" formGroupName="compostabilityForm">
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="compostabilityHigh"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Compostability high"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Compostability high</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityHigh')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityHigh')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityHigh')
                      ?.errors
                  "
                >
                  Compostability high is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="compostabilityLow"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Compostability  Low"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Compostability low</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityLow')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityLow')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityLow')
                      ?.errors
                  "
                >
                  Compostability low is required.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <div class="services-form">
              <input
                formControlName="compostabilityNone"
                type="number"
                maxlength="30"
                class="input-custom-style"
                placeholder="Compostability none"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>Compostability none</label>
              <div
                *ngIf="
                  (finalSubmitted &&
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityNone')
                      ?.errors) ||
                  otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityNone')
                    ?.touched
                "
                class="input-error"
              >
                <div
                  *ngIf="
                    otherMaterialAddEditForm.get('compostabilityForm')?.get('compostabilityNone')
                      ?.errors
                  "
                >
                  Compostability none is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
